import { render, staticRenderFns } from "./TopKeywordEvolutionTable.vue?vue&type=template&id=5f1e73f5"
import script from "./TopKeywordEvolutionTable.vue?vue&type=script&lang=js"
export * from "./TopKeywordEvolutionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports